export default {
      id: "i-finam-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "img/sprite.svg#i-finam",
      toString: function () {
        return this.url;
      }
    }